/**
 * Cookie操作函数
 */
class Cookie {
    /**
     * 获取Cookie
     * @param {cookie} name cookie名称
     */
    static get(name) {
        // 注意对键编码
        const cookieName = `${encodeURIComponent(name)}=`;
        const cookieStart = document.cookie.indexOf(cookieName);
        let cookieValue = '';
        let cookieEnd;
        // 找到cookie键
        if (cookieStart > -1) {
            // 键后面第一个分号位置
            cookieEnd = document.cookie.indexOf(';', cookieStart);
            if (cookieEnd === -1) {
                cookieEnd = document.cookie.length;
            }
            // cookie值解码
            cookieValue = decodeURIComponent(document.cookie.substring(cookieStart + cookieName.length, cookieEnd));
        }
        return cookieValue;
    }
    /**
     * 设置Cookie
     * @param {String} name cookie名称
     * @param {String} value cookie值
     * @param {String} option cookie配置项
     */
    static set(name, value, option = {}) {
        // document.cookie = "key=value; path=path; domain=domain; max-age=max-age-in-seconds; expires=date-in-GMTString-format";
        const { path, expires, domain } = option;
        let cookieText = `${encodeURIComponent(name)}=${encodeURIComponent(value)}`;
        // @ts-ignore
        cookieText += expires ? `; expires=${expires.toGMTString()}` : '';
        cookieText += path ? `; path=${path}` : '';
        cookieText += domain ? `; domain=${domain}` : '';
        document.cookie = cookieText;
    }
    /**
     * 清除cookie
     * @param {any} name cookie名称
     */
    static clear(name) {
        this.set(name, '', { expires: new Date(0) });
    }
}
export const cookie = Cookie;
